var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7475 3.27495C17.7433 2.22734 16.0723 2.25889 15.0647 3.26655L3.19852 15.1327C3.03656 15.2947 2.9351 15.5073 2.91112 15.7351L2.51343 19.5133C2.37207 20.6525 3.34754 21.6279 4.48675 21.4866L8.26485 21.0889C8.49265 21.0649 8.70531 20.9634 8.86727 20.8015L20.7334 8.9353C21.7411 7.92765 21.7726 6.25673 20.7251 5.2525L18.7475 3.27495ZM17.3061 4.6614C17.1125 4.4571 16.7308 4.42885 16.4789 4.68076L15.3247 5.83501L18.165 8.67534L19.3192 7.52108C19.5711 7.26918 19.5429 6.88746 19.3386 6.69392C19.3321 6.68773 19.3256 6.68144 19.3192 6.67507L17.3249 4.68076C17.3185 4.67439 17.3123 4.66794 17.3061 4.6614ZM16.7508 10.0895L13.9104 7.24923L4.86307 16.2966L4.52892 19.4711L7.7034 19.1369L16.7508 10.0895Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenX2);
export default __webpack_public_path__ + "static/media/EditPenX2.38c920fda43e2c4e0b28a184d7fc94fe.svg";
export { ForwardRef as ReactComponent };